export default {
  bind (el, binding, v) {
    let key = Object.keys(binding.value).pop()
    el.dataset.trackContext = key
    el.dataset.trackValue = binding.value[key]
  }
}
